import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import { ErrorPixResponse, ErrorPixDownloadResponse } from "../types";

export const errorPixService = {
  async getErrorPixData(dbName: string): Promise<ApiResponse<ErrorPixResponse>> {
    return apiClient.post<ErrorPixResponse>("/gestorErrorPixViz", {
      dbName,
    });
  },

  async downloadErrorPixFiles(dbName: string): Promise<ApiResponse<ErrorPixDownloadResponse>> {
    return apiClient.post<ErrorPixDownloadResponse>("/gestorErrorPixDownload", {
      dbName,
    });
  },
};
